import {Utilities} from '../../shared/utilities/utilities.model';
/**
 * obbligatori
 * TXT_TREAD_WIDTH
 * TXT_WHEEL_DIAMETER
 * TXT_LOAD_RATING
 * TXT_RATIO
 * TXT_SPEED_RATING
 */
export class Axis {
	txt_make: string;
	txt_season: string;
	txt_tread_width: string;
	txt_wheel_diameter: string;
	txt_load_rating: string;
	txt_ratio: string;
	txt_speed_rating: string;
	dot_week: any;
	dot_year: any;
	txt_tipologia: string;
	txt_deposit: string;

	constructor(model?: any) {
		if (model) {
			this.txt_make = model.txt_make;
			this.txt_season = model.txt_season;
			this.txt_tread_width = model.txt_tread_width;
			this.txt_wheel_diameter = model.txt_wheel_diameter;
			this.txt_load_rating = model.txt_load_rating;
			this.txt_ratio = model.txt_ratio;
			this.txt_speed_rating = model.txt_speed_rating;
			if (!Utilities.isVoid(model.dot_week)) {
				const dotWeek = parseFloat(model.dot_week);
				this.dot_week = isNaN(dotWeek) ? '' : dotWeek;
			}
			if (!Utilities.isVoid(model.dot_year)) {
				const dotYear = parseFloat(model.dot_year);
				this.dot_year = isNaN(dotYear) ? '' : dotYear;
			}
			this.txt_tipologia = model.txt_tipologia;
			if (!Utilities.isVoid(model.txt_deposit)) {
				this.txt_deposit = model.txt_deposit;
			}
		}
		this.countValidField();
	}

	isReady(): boolean {
		const res: boolean = (!Utilities.isVoid(this.txt_tread_width) && this.txt_tread_width.length > 0)
			&& (!Utilities.isVoid(this.txt_wheel_diameter) && this.txt_wheel_diameter.length > 0)
			&& (!Utilities.isVoid(this.txt_load_rating) && this.txt_load_rating.length > 0)
			&& (!Utilities.isVoid(this.txt_ratio) && this.txt_ratio.length > 0)
			&& (!Utilities.isVoid(this.txt_speed_rating) && this.txt_speed_rating.length > 0);
		return res;
	}

	countValidField(): number {
		let count = 0;
		if (!Utilities.isVoid(this.txt_tread_width) && this.txt_tread_width.length > 0) count++;
		if (!Utilities.isVoid(this.txt_wheel_diameter) && this.txt_wheel_diameter.length > 0) count++;
		if (!Utilities.isVoid(this.txt_load_rating) && this.txt_load_rating.length > 0) count++;
		if (!Utilities.isVoid(this.txt_ratio) && this.txt_ratio.length > 0) count++;
		if (!Utilities.isVoid(this.txt_speed_rating) && this.txt_speed_rating.length > 0) count++;
		return count;
	}

	update(model: Axis) {
		if (model) {
			this.txt_make = model.txt_make;
			this.txt_season = model.txt_season;
			this.txt_tread_width = model.txt_tread_width;
			this.txt_wheel_diameter = model.txt_wheel_diameter;
			this.txt_load_rating = model.txt_load_rating;
			this.txt_ratio = model.txt_ratio;
			this.txt_speed_rating = model.txt_speed_rating;
			const dotWeek = parseFloat(model.dot_week);
			this.dot_week = isNaN(dotWeek) ? '' : dotWeek;
			const dotYear = parseFloat(model.dot_year);
			this.dot_year = isNaN(dotYear) ? '' : dotYear;
			this.txt_tipologia = model.txt_tipologia;
			if (!Utilities.isVoid(model.txt_deposit)) {
				this.txt_deposit = model.txt_deposit;
			}
		}
	}

	isChanged(model: Axis) {
		return Utilities.isVoid(model) || this.txt_make !== model.txt_make || this.txt_season !== model.txt_season
			|| this.txt_wheel_diameter !== model.txt_wheel_diameter || this.txt_load_rating !== model.txt_load_rating
			|| this.txt_speed_rating !== model.txt_speed_rating || this.dot_week !== model.dot_week || this.dot_year !== model.dot_year
			|| this.txt_tipologia !== model.txt_tipologia || this.txt_deposit !== model.txt_deposit || this.txt_ratio !== model.txt_ratio
			|| this.txt_tread_width !== model.txt_tread_width;
	}
}
